import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { logError } from "@faire/web--source/common/logging";
import { SafelySetInnerHTML } from "@faire/web--source/common/SafelySetInnerHTML";
import { ZendeskArticle } from "@faire/web--source/common/zendesk/styles";
import Color from "@faire/web--source/slate/Color";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import React from "react";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { useTosArticle } from "./useTosArticle";
export var TermsOfServices = function(param) {
    var type = param.type;
    var _useTosArticle = useTosArticle(type), body = _useTosArticle.body, isLoading = _useTosArticle.isLoading;
    if (isLoading) {
        return /*#__PURE__*/ _jsxs(Column, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "7x"
                }),
                /*#__PURE__*/ _jsx(LoadingSpinner, {})
            ]
        });
    }
    if (body.length === 0) {
        logError("Incomplete TOS Content");
        return /*#__PURE__*/ _jsx(Redirect, {
            to: home()
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: "7x"
            }),
            /*#__PURE__*/ _jsx(ContentWrapper, {
                children: /*#__PURE__*/ _jsx(StyledBody, {
                    children: /*#__PURE__*/ _jsx(SafelySetInnerHTML, {
                        html: body
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
};
var ContentWrapper = styled(Column).withConfig({
    componentId: "sc-a290b59d-0"
})([
    "width:100%;max-width:800px;padding-bottom:",
    ";"
], getSpacing("4x"));
var StyledBody = styled(ZendeskArticle).withConfig({
    componentId: "sc-a290b59d-1"
})([
    "padding:0 ",
    ";h1{",
    " margin-bottom:",
    ";}ol{padding:0;list-style:lower-latin;li{list-style-type:inherit;margin:",
    " 0 0 ",
    ";}}ul{padding:0;list-style:circle;}table{margin-top:",
    ";td{border:1px solid ",
    ";padding:",
    ";p{margin:0;}}}"
], getSpacing("2x"), TypographyStyles({
    variant: "displaySSerifRegular",
    align: "center"
}), getSpacing("4x"), getSpacing("2x"), getSpacing("3x"), getSpacing("1x"), Color.faireBlack, getSpacing("1x"));
